import { render, staticRenderFns } from "./PageFoundations.vue?vue&type=template&id=3575cbc9&"
import script from "./PageFoundations.vue?vue&type=script&lang=js&"
export * from "./PageFoundations.vue?vue&type=script&lang=js&"
import style0 from "./PageFoundations.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports